module.exports = __webpack_public_path__ + "static/media/Female.5c4655fd.svg";